import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const DispatchPlaces = ({data}) => {

  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.dispatch_factplace);

    GraphicUtils.barChart('dispatch-places', values, labels, false, true, 3);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, "Des. por locais pré-cadastrados");

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">Despachos por locais pré-cadastrados {data?.length >= 5 ? ' (TOP 5)' : ''}</span>
        <div className="mt-3" id="dispatch-places"></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchPlaces;